import { MIconButton, MIcons, MTooltip } from "@material-dev/insights-portal-ui-components";
import { memo, useCallback } from "react";
import { useStyles } from "./SelectedLabelStyles";

export type SelectedLabelProps = {
  id: unknown;
  name: string | undefined;
  onDelete: (id: unknown) => void;
  className?: string;
  tooltip?: string;
};
export const SelectedLabel = memo<SelectedLabelProps>(({ id, name, onDelete, className, tooltip }) => {
  const { classes, cx } = useStyles();
  const handleDeleteClick = useCallback(() => {
    onDelete(id);
  }, [onDelete, id]);

  return (
    <div className={cx(classes.root, className)}>
      <div>
        <MIconButton className={classes.btnRemove} onClick={handleDeleteClick}>
          <MIcons.Remove fontSize="small" />
        </MIconButton>
      </div>
      <MTooltip title={tooltip ?? ""}>
        <div className={classes.label}>{name}</div>
      </MTooltip>
    </div>
  );
});

export default SelectedLabel;
